import { Token } from '../../../logic/token/token'
import { Wei } from '../../../utils/types'

export interface BalanceState {
  displayed: boolean
  token?: Token
  loading: boolean
  value?: Wei
}

export interface BalanceAction {
  type: 'loading' | 'loaded' | 'force-value' | 'disconnect'
  token?: Token
  value?: Wei
}

export const BALANCE_INITIAL_STATE: BalanceState = {
  displayed: false,
  token: undefined,
  loading: false,
  value: undefined,
}

export function balanceReducer(
  state: BalanceState,
  action: BalanceAction
): BalanceState {
  switch (action.type) {
    case 'loading':
      return {
        ...state,
        loading: true,
        token: action.token,
        displayed: true,
      }
    case 'loaded':
      return {
        ...state,
        loading: false,
        value: action.value!,
      }
    case 'force-value':
      return {
        ...state,
        loading: false,
        value: action.value!,
        displayed: true,
      }
    case 'disconnect':
      return { ...BALANCE_INITIAL_STATE }
  }
  return state
}
